<template>
  <el-tooltip :disabled="showTooltip" :placement="placement">
    <template slot="content">
      <span>{{ content || $emptyFormat(text) }}</span>
    </template>

    <div :class="lineNumber > 1 ? 'text-ellipsis-multiple' : 'text-ellipsis'" :style="lineNumber > 1 ? { '-webkit-line-clamp': lineNumber } : ''" @mouseenter.stop="onMouseEnter">
      {{ $emptyFormat(text) }}
    </div>
  </el-tooltip>
</template>

<script>
export default {
  props: {
    text: String | Number,
    placement: {
      type: String,
      default: 'top'
    },
    content: String,
    lineNumber: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      showTooltip: true
    }
  },
  methods: {
    onMouseEnter(e) {
      const dom = e.target
      this.showTooltip = !(dom.offsetWidth < dom.scrollWidth || dom.offsetHeight < dom.scrollHeight)
    }
  }
}
</script>

<style lang="scss" scoped>
.text-ellipsis-multiple {
  word-break: break-word;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -moz-box;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -moz-box-orient: vertical;
}

.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/common/BaseToolTip.vue